import type { components } from '@/api/schema'
import type { QuoteBuilderApi } from '../api/client'

// Voice transport (demo `features/ai/api.ts` live and transcription calls, `assistant-types.ts`).

type Schemas = components['schemas']

export type LiveSessionRequest = Schemas['QbLiveSessionRequest']
export type LiveSessionResponse = Schemas['QbLiveSessionResult']
export type TranscriptionResult = Schemas['QbTranscriptionResult']
export type VoiceRequest = Schemas['QbVoiceRequestCreate']
export type VoiceRequestResult = Schemas['QbVoiceRequestResult']
export type LiveTranscript = {
  event_id: string
  sessionId: string
  role: 'user' | 'assistant'
  delta: string
  start_ms: number
  end_ms: number
  order?: number
}

export const transcribeRecording = (api: QuoteBuilderApi, audio: string, format: string, signal?: AbortSignal) =>
  api.request<TranscriptionResult>('/ai/transcription', { method: 'POST', body: JSON.stringify({ audio, format }), signal })

/** What the caller said, written as a clean request for the quote assistant (empty: nothing to do). */
export const writeVoiceRequest = (api: QuoteBuilderApi, request: VoiceRequest) =>
  api.request<VoiceRequestResult>('/ai/live/request', { method: 'POST', body: JSON.stringify(request) })

// Creating a paid media session is not a retryable assistant turn.
export const createLiveSession = (api: QuoteBuilderApi, request: LiveSessionRequest, signal: AbortSignal) =>
  api.request<LiveSessionResponse>('/ai/live/sessions', { method: 'POST', body: JSON.stringify(request), signal })

/** Billed voice duration for the AI Costs page; best effort, never blocks the conversation. */
export const reportLiveUsage = (api: QuoteBuilderApi, sessionId: string, seconds: number, final: boolean) =>
  api
    .request<void>(`/ai/live/sessions/${encodeURIComponent(sessionId)}/usage`, {
      method: 'POST',
      body: JSON.stringify({ seconds, final }),
      keepalive: true,
    })
    .catch(() => undefined)
